package music.limasoul.client.shared.instrument.data.repository

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import music.jammers.shared.instrument.domain.model.InstrumentType
import music.limasoul.client.shared.instrument.domain.repository.InstrumentRepository

class InstrumentRepositoryImpl(
    private val httpClient: HttpClient,
) : InstrumentRepository {

    override suspend fun availableForEvent(eventId: Long): List<InstrumentType> =
        httpClient.get("events/$eventId/instruments").body()
}